import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PodrucjeznanjaPopisService } from './podrucjeznanja-popis.service';
import { PodrucjeznanjaPopis } from './podrucjeznanja';
import { Subject } from 'rxjs';
import * as toastr from 'toastr';
import * as alertify from 'alertify.js';

@Component({
  selector: 'app-podrucjeznanja-popis',
  templateUrl: './podrucjeznanja-popis.component.html',
  styleUrls: ['./podrucjeznanja-popis.component.css'],
  providers: [ PodrucjeznanjaPopisService ]
})
export class PodrucjeznanjaPopisComponent implements OnInit {

  svaPodrucjaznanja: PodrucjeznanjaPopis[] = [];
  podrucjeznanjaOptions: DataTables.Settings = {};
  podrucjeznanjaTrigger: Subject<PodrucjeznanjaPopis> = new Subject();

  podrucjeznanjaForma: FormGroup;
  podrucjeznanjaEditForma: FormGroup;

  podrucjeznanjaId: string;

  constructor(
    private _fb: FormBuilder,
    private _podrucjeznanjaPopisService: PodrucjeznanjaPopisService
  ) { }

  ngOnInit() {
    this.dohvati();
    //Tablica početak
    this.podrucjeznanjaOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
        targets: 'no-sort',
        orderable: false
      }],
      retrieve: true
    };
    //Tablica kraj
    this.podrucjeznanjaForma = this._fb.group({
      naziv: [''],
    });
    this.podrucjeznanjaEditForma = this._fb.group({
      naziv: [''],
      aktivan: ['']
    });
  }

  pripremiPodatke(podrucje){
    //console.log(podrucje);
    this.podrucjeznanjaId = podrucje['id'];
    this.podrucjeznanjaEditForma = this._fb.group({
      naziv: podrucje['naziv'],
      aktivan: podrucje['aktivan']
    });
  }

  uredi(podrucje){
    //console.log(podrucje);
    let podaciZaSlanje = {
      'idpodrucjeznanja': this.podrucjeznanjaId,
      'naziv': podrucje['naziv'],
      'aktivan': podrucje['aktivan'],
      'access_token': localStorage.getItem('tokenSql')
    }
    //console.log(podaciZaSlanje);
    this._podrucjeznanjaPopisService.urediPodrucjeznanja(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        $('#podrucjeznanjaTablica').DataTable().destroy();
        this.dohvati();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  spremi(podrucjeznanjaForma){
    //console.log(podrucjeznanjaForma);
    let objektZaSlanje = {
      'naziv': podrucjeznanjaForma['naziv']
    }
    //console.log(objektZaSlanje);
    if(podrucjeznanjaForma['naziv']){
      this._podrucjeznanjaPopisService.dodajPodrucjeznanja(objektZaSlanje).subscribe(res => {
        //console.log(res);
        if(res.success == true){
          toastr.success("Uspješno dodano područje znanja!");
          this.podrucjeznanjaForma = this._fb.group({
            naziv: ['']
          });
          $('#podrucjeznanjaTablica').DataTable().destroy();
          this.dohvati();
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  dohvati(){
    this.svaPodrucjaznanja = [];
    this._podrucjeznanjaPopisService.dohvatiSve({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.svaPodrucjaznanja.push({
            'id': res.data[i]['idpodrucjeznanja'],
            'naziv': res.data[i]['pu_naziv'],
            'aktivan': res.data[i]['pu_aktivan']
          });
        }
        this.podrucjeznanjaTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  obrisiPodrucjeznanja(podrucje){
    //console.log(podrucje);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati područje znanja?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._podrucjeznanjaPopisService.obrisiPodrucjeznanja({'idpodrucjeznanja': podrucje.id}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Područje znanja uspješno obrisano!");
            $('#podrucjeznanjaTablica').DataTable().destroy();
            ovo.dohvati();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja područja znanja.');
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/podrucjeznanja-popis/podrucjeznanja-popis.component.ts